<div class="p-col-12 ui-md-12">
    <h2>{{'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_MSG' | translate}}</h2>
    <p> {{'ARC_SHARED_COMPONENTS_PRESENTATION_FORCE_PASSWORD_REQ_DESCRIPTION' | translate}}</p>
</div>
<app-authentication-passwordreset [backButtonVisible]="false"
    (resetPasswordClicked)="onResetPasswordClick($event)"></app-authentication-passwordreset>

<div class="p-col-12 ui-md-12 tertiary-wrapper">
    <button aur-button type="button" (click)="goBack($event)" icon="arrow_back" importance="tertiary">{{
        'ARC_SHARED_COMPONENTS_BACK'
        | translate }}</button>
</div>